<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" class="w-full h-full flex">
    <Transition>
      <div
        v-if="modal"
        style="
          position: fixed;
          top: 0;
          width: 40vw;
          height: 100vh;
          z-index: 999999;
        "
        class="bg-"
        :style="[modalPos ? { left: 0 } : { right: 0 }]"
      >
        <vs-card
          class="cardx p-2"
          fixedHeight
          style="
            margin: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          "
        >
          <div class="d-flex justify-content-between align-items-center pl-2">
            <!----><!---->
            <div class="truncate">
              <h5 class="mb-25">
                {{ selectedModal.name }}
              </h5>
            </div>
            <span
              class="flex justify-center items-center rounded-full relative overflow-hidden cursor-pointer"
              @click="modal = false"
              style="width: 45px; height: 45px"
            >
              <span class="b-avatar-custom relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  />
                </svg>
              </span>
            </span>
          </div>
          <div style="max-height: 90vh" class="overflow-auto">
            <vs-list
              v-for="(step2, index2) of selectedModal.data"
              :key="index2"
            >
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Idling'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Idling Time ' + step2.idlingStatus }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="
                  step2 &&
                  selectedModal.name == 'Assets in Places of Interest (POI)'
                "
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Idling Time ' + step2.idlingStatus }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Moving'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Refuels'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }}</router-link
                  >
                  -
                  <a
                    target="_blank"
                    :href="`https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;&amp;q=${step2.coordinates}`"
                    ><b>{{
                      'Refuel ' +
                      step2.refuelVolume +
                      'L' +
                      ' at ' +
                      step2.refuelTime
                    }}</b></a
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row justify="center" v-else>
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
            </vs-list>
          </div>
        </vs-card>
      </div>
    </Transition>
    <vs-progress
      class="absolute top-0 left-0"
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>
    <layout>
      <template #top>
        <vs-card class="cardx p-2" fixedHeight style="margin: 0">
          <h4>Fleet Status</h4>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="donut"
                :options="movementChartOptions"
                :series="movementChartSeries"
                height="220"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  icon="near_me"
                  subtitle="Move"
                  :title="movementChartSeries[0]"
                  style="color: #28c76f"
                ></vs-list-item>
                <vs-list-item
                  icon="pause_circle"
                  subtitle="Idle"
                  :title="movementChartSeries[1]"
                  style="color: #ff9f43"
                ></vs-list-item>
                <vs-list-item
                  icon="stop_circle"
                  subtitle="Park"
                  :title="movementChartSeries[2]"
                  style="color: #ea5455"
                ></vs-list-item>
                <vs-list-item
                  icon="signal_wifi_bad"
                  subtitle="Inactive"
                  :title="movementChartSeries[3]"
                  style="color: #b4a5a5"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-card class="cardx p-2" fixedHeight style="margin: 0">
          <h4>Temperature</h4>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="donut"
                :options="spikeChartOptions"
                :series="spikeChartSeries"
                height="220"
                @click="
                  (event, chartContext, config) => {
                    getSpikeData(!config.dataPointIndex ? 'normal' : 'spike');
                  }
                "
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  icon="thermostat"
                  subtitle="Normal"
                  :title="spikeChartSeries[0]"
                  style="color: #28c76f; cursor: pointer"
                  @click.native="getSpikeData('normal')"
                ></vs-list-item>
                <vs-list-item
                  icon="thermostat"
                  subtitle="Spike"
                  :title="spikeChartSeries[1]"
                  style="color: #ea5455; cursor: pointer"
                  @click.native="getSpikeData('spike')"
                ></vs-list-item>
              </vs-list>
              <vs-popup
                class="holamundo"
                :title="
                  String(spikeDataModalData).charAt(0).toUpperCase() +
                  String(spikeDataModalData).slice(1)
                "
                :active.sync="spikeDataModal"
              >
                <vs-table
                  v-if="spikeDataModalData"
                  :data="spikeData[spikeDataModalData]"
                  stripe
                >
                  <template slot="thead">
                    <vs-th> No </vs-th>
                    <vs-th> Name </vs-th>
                    <vs-th> Current Temp </vs-th>
                    <vs-th> Preferred Temp </vs-th>
                    <vs-th> Time</vs-th>
                    <vs-th> Action</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <span>
                          <b>{{ indextr + 1 }}</b></span
                        >
                      </vs-td>
                      <vs-td
                        v-for="(td, indextd) in [
                          'assetName',
                          'currentTemp',
                          'preferredTemp',
                          'time',
                        ]"
                        :data="tr"
                      >
                        {{ data[indextr][td] }}
                      </vs-td>

                      <vs-td>
                        <vs-button
                          @click.native="goToAsset(tr)"
                          color="primary"
                          type="border"
                          icon="monitor"
                        ></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-popup>
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-card class="cardx" fixedHeight style="margin: 0">
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
              <h4>Fleet Usage (KM)</h4>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
            </vs-col>
          </vs-row>

          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="bar"
                height="220"
                :options="mileageChartOptions"
                :series="mileageSeries"
                :key="refreshKey"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  subtitle="Usage Last 24hrs"
                  :title="mileageData[2] + ' km'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Overall Usage"
                  :title="mileageData[0] + ' km'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Average per Asset"
                  :title="mileageData[1] + ' km'"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>

        <vs-card class="cardx m-0 flex flex-col justify-between h-full">
          <h4>Fleet Idle</h4>
          <br />
          <div class="flex flex-col gap-8 flex-grow h-full items-stretch mt-4">
            <div
              class="d-flex justify-content-between mb-1"
              v-for="(n, i) in [
                'Current Idle Time',
                'Approx Fuel Waste',
                'Approx Fuel Waste Cost',
              ]"
              :key="n"
            >
              <div class="series-info flex items-center">
                <span
                  class="flex justify-center items-center rounded-full relative overflow-hidden"
                  style="width: 45px; height: 45px"
                >
                  <div
                    class="h-full w-full bg-danger absolute opacity-25"
                  ></div>
                  <span class="b-avatar-custom relative">
                    <component :is="`Icon${n.replace(/\s/g, '')}`" />
                  </span>
                </span>
                <h4 class="font-weight-bolder ml-4 mb-0" style="color: #ff9f43">
                  {{ n }}
                </h4>
              </div>
              <div class="h-full w-48 flex items-center justify-end mb-0">
                <h5>
                  <span v-if="i == 2">RM</span> {{ idleStat[i] }}
                  <span v-if="i != 2">{{ ['hours', 'liters'][i] }}</span>
                </h5>
              </div>
            </div>
          </div>
        </vs-card>
      </template>

      <template #mid>
        <vs-card
          class="cardx m-0"
          fixedHeight
          v-for="(n, i) in [
            'Overspeeding',
            'Backup Battery Alert',
            'Unauthorized Ignition',
            'Immobilizer',
          ]"
          :key="i"
        >
          <h4>{{ n }}</h4>
          <div
            class="card-body d-flex justify-content-between align-items-center pl-2"
          >
            <!----><!---->
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder" style="color: #ff9f43">
                {{ alarmData[i] + ' times' }}
              </h2>
              <span>Last 12 hrs</span>
              <span v-if="i == 0"> - Over 80kph</span>
            </div>
            <span
              class="flex justify-center items-center rounded-full relative overflow-hidden"
              style="width: 45px; height: 45px"
            >
              <div class="h-full w-full bg-danger absolute opacity-25"></div>
              <span class="b-avatar-custom relative">
                <component :is="`Icon${n.replace(/\s/g, '')}`" />
              </span>
            </span>
          </div>
        </vs-card>
      </template>

      <template #bot>
        <vs-card
          class="cardx m-0"
          fixedHeight
          v-for="(n, i) in [
            { name: 'Assets in Places of Interest (POI)', data: locationStat },
            {
              name: 'Moving / Idling / Refuels ',
              data: [
                { name: 'Moving', data: longStatMovement },
                { name: 'Idling', data: longStatIdle },
                { name: 'Refuels', data: refuelStat },
              ],
            },
          ]"
          :key="i"
        >
          <h4>{{ n.name }}</h4>
          <div style="max-height: 320px" class="overflow-auto w-full mt-8">
            <div
              v-for="(step, index) of n.data"
              :key="index"
              class="cursor-pointer hover:bg-grey py-1"
              @click="
                modal = true;
                i == 1
                  ? step.data.length == 0
                    ? (modal = false)
                    : void 0
                  : void 0;
                selectedModal = i == 0 ? { name: index, data: step } : step;
                modalPos = i == 0 ? false : true;
              "
            >
              <div
                class="d-flex justify-content-between align-items-center pl-2"
              >
                <!----><!---->
                <div class="truncate" v-if="index != 2">
                  <h5 class="mb-25" v-if="i == 0">
                    {{ index }} ({{ step.length }} assets)
                  </h5>
                  <h5 class="mb-25" v-if="i == 1 && step.data.length != 0">
                    {{ step.name }} (

                    {{ step.data.length }}
                    assets)
                  </h5>
                  <!-- <h5 class="mb-25">{{ index }} ({{ step.length }} assets)</h5> -->
                </div>
                <div class="truncate" v-if="index == 2">
                  <h5 class="mb-25" v-if="i == 0">
                    {{ index }} ({{ step.length }} times)
                  </h5>
                  <h5 class="mb-25" v-if="i == 1 && step.data.length != 0">
                    {{ step.name }} (

                    {{ step.data.length }}
                    times)
                  </h5>
                  <!-- <h5 class="mb-25">{{ index }} ({{ step.length }} assets)</h5> -->
                </div>
                <span
                  class="flex justify-center items-center rounded-full relative overflow-hidden"
                  style="width: 45px; height: 45px"
                >
                  <span class="b-avatar-custom relative"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M11 17h2v-6h-2v6Zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.713T12 7q-.425 0-.713.288T11 8q0 .425.288.713T12 9Zm0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Zm0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20Zm0-8Z"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              <vs-divider class="m-0" />
            </div>
          </div>
        </vs-card>
      </template>
    </layout>
  </div>
</template>

<script>
import Layout from './Layout.vue';
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';

import IconOverspeeding from './IconOverspeeding.vue';
import IconBackupBatteryAlert from './IconBackupBatteryAlert.vue';
import IconImmobilizer from './IconImmobilizer.vue';
import IconUnauthorizedIgnition from './IconUnauthorizedIgnition.vue';
import IconCurrentIdleTime from './IconCurrentIdleTime.vue';
import IconApproxFuelWaste from './IconApproxFuelWaste.vue';
import IconApproxFuelWasteCost from './IconApproxFuelWasteCost.vue';
import { options } from 'fusioncharts';

export default {
  components: {
    VueApexCharts,
    moment,
    Layout,
    IconOverspeeding,
    IconBackupBatteryAlert,
    IconUnauthorizedIgnition,
    IconImmobilizer,
    IconCurrentIdleTime,
    IconApproxFuelWaste,
    IconApproxFuelWasteCost,
  },
  data() {
    return {
      modal: false,
      modalPos: false,
      selectedModal: null,
      refreshKey: 0,
      unreadNotif: localStorage.getItem('unreadNotif') || 0,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      allUnits: JSON.parse(localStorage.getItem('allUnits')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      locationStat: [],
      alarmData: [0, 0, 0, 0],
      tableListener: null,
      alarmSummaryData: [],
      longStatMovement: [],
      isLoading: true,
      longStatIdle: [],
      refuelStat: [],
      mileageSeries: [
        {
          name: 'Usage Last 24 hours (km)',
          data: [0, 0, 0, 0, 0],
        },
      ],
      mileageData: [0, 0, 0],
      idleStat: [0, 0, 0],
      movementChartSeries: [0, 0, 0, 0],
      movementChartOptions: {
        chart: {
          height: 200,
          type: 'radialBar',
        },
        colors: ['#28C76F', '#FF9F43', '#EA5455', '#b4a5a5'],
        labels: ['Move', 'Idle', 'Park', 'Inactive'],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                },
              },
            },
          },
        },
      },
      spikeData: null,
      spikeDataModal: false,
      spikeDataModalData: null,
      spikeChartSeries: [0, 0, 0, 0],
      spikeChartOptions: {
        chart: {
          height: 200,
          type: 'radialBar',
        },
        colors: ['#28C76F', '#EA5455'],
        labels: ['Normal', 'Spike'],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                },
              },
            },
          },
        },
      },
      mileageChartOptions: {
        chart: {
          type: 'bar',
          height: 200,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['', '', '', '', ''],
          title: {
            text: 'Top Usage',
          },
        },
      },

      hoursChartSeries: [0, 0, 0],
    };
  },
  created() {},
  methods: {
    getSpikeData(type) {
      if (!this.spikeData) return;
      this.spikeDataModal = true;
      this.spikeDataModalData = type;
    },
    goToAsset(tr) {
      const routeData = this.$router.resolve({
        name: 'monitor',
        params: { assetId: tr.assetId, assetName: tr.assetName, view: 'map' },
      });
      window.open(routeData.href, '_blank');
    },
    getStats() {
      var self = this;
      let selectedUnits2 = [];
      self.unitSelection.forEach((e) => {
        selectedUnits2.push(e.unitId);
      });
      self.$http
        .post('chartsWebv2/' + self.userInfo.uid, {
          selectedUnits: self.allUnits,
          selectedUnits2: selectedUnits2,
          geoPOIData: self.geoPOIData,
          fuelPrice: self.userInfo.fuelPrice || 2.15,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.spikeData = response.data.spikeData;
            self.movementChartSeries = response.data.stat;
            self.spikeChartSeries = response.data.spikeStat;
            self.hoursChartSeries = response.data.hoursStat;
            self.locationStat = response.data.locationStat;
            self.longStatIdle = response.data.longStatIdle;
            self.longStatMovement = response.data.longStatMovement;
            self.refuelStat = response.data.refuelStat;
            self.mileageChartOptions.xaxis.categories =
              response.data.mileageSeriesLabel;
            self.mileageSeries[0].data = response.data.mileageSeries;
            self.mileageData = response.data.mileageData;
            self.idleStat = response.data.idleStat;
            self.alarmSummaryData = response.data.alarmSummaryData;
            self.alarmData = response.data.alarmData;
            self.refreshKey += 1;
            self.isLoading = false;
            self.tableListener = setTimeout(() => {
              self.getStats();
            }, 80000);
          }
          // else {
          // }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    try {
      var self = this;
      self.getStats();
      self.$http
        .post('clients/getSelection/' + self.userInfo.uid + '/Web', {
          userInfo: self.userInfo,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            localStorage.setItem(
              'allUnits',
              JSON.stringify(response.data.allUnits),
            );
            localStorage.setItem(
              'unitSelection',
              JSON.stringify(response.data.unitSelection),
            );
            localStorage.setItem(
              'mapPOIData',
              JSON.stringify(response.data.mapPOIData),
            );
            localStorage.setItem(
              'geoPOIData',
              JSON.stringify(response.data.geoPOIData),
            );
            localStorage.setItem(
              'userInfo',
              JSON.stringify(response.data.userInfo),
            );
          } else {
            // if (response.data.error) {
            // }
            // else {
            // }
          }
        })
        .catch(function (error) {});
    } catch (error) {
      console.error(error);
    }
  },
  destroyed() {
    if (this.tableListener) {
      clearTimeout(this.tableListener);
    }
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

.cardx {
  padding: 0.5rem;
}
td .tooltip {
  position: absolute;
}
/*! rtl:end:ignore */
</style>
